import { PlayAudiosService } from './../audios/playAudios.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ModalSelecaoVolumesComponent } from 'src/app/@shared/components';
import { TipoConsultaBarcode } from 'src/app/@shared/enum/tipoConsultaBarcode';
import { ValidarManifestoTransferenciaResponse } from 'src/app/@shared/models/manifesto-transferencia.model';
import { DEF_VOL_COLS, ObjetoGridVolumes, ObjGridVolCols } from 'src/app/@shared/models/selecao-volumes/objeto-grid-volumes.model';
import { BarcodeListarRequest, BarcodeListarResponse, SelecaoVolumes, Volume } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';
import { ManifestoTransferenciaService } from '../manifesto-transferencia/manifesto-transferencia.service';
import { ModalErroMensagemComponent } from 'src/app/@pages/pre-manifesto-transferencia/modal-erro-mensagem/modal-erro-mensagem/modal-erro-mensagem.component';
import { ToastrService } from 'ngx-toastr';
export interface PedidoVolume {
  pedidoId: number;
  pedEtiqueta: number;
}

type ModalSelecaoVolumeCallback = (selecao: SelecaoVolumes) => any;
@Injectable({
  providedIn: 'root'
})
export class ConsultaBarcodeService {

  public onPackageSelected: EventEmitter<Volume | any> = new EventEmitter();
  public updateLoading: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public manifestoService: ManifestoTransferenciaService,
    public playAudiosService: PlayAudiosService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef : MatDialog,
    private toastr: ToastrService,
  ) { }

  public consultarBarcodeRecepcaoUnitaria(barcode, objetoGrid: ObjetoGridVolumes<any>, flgImprimirEtiqueta = false, alpha?: string) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.RECEPCAO_MANIFESTO_TRANSFERENCIA,
      flgImprimirEtiqueta,
      alpha
    };

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        if(!response || response[0]?.pedido == null){
          let mensagemErro = response[0]?.erro.replace(/;/g, '<br>');

          if(!mensagemErro || mensagemErro == "") 
            mensagemErro = 'Não encontrei o pacote bipado. Tente bipar outro código de barras.';

          this.playAudiosService.playAudioError();
          this.openDialog('Erro', mensagemErro, 'Fechar');
          return;
        }
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);
         
          const filtrado = this.removeExistentes(vols, response);
          if (filtrado?.length) {
            const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcodeRecepcaoUnitaria(result.pedido.pedidoId, objetoGrid);
                }
              }
            );
          } else {
            //debugger
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            if (!pedidoEtiqueta) {
              if(barcode == pedidoId){
                this.consultaBarcodeManifestoTransferencia(pedidoId,objetoGrid);
                //this.toastrError('Não há manifesto para o código de barras informado.')
              } else {
                this.consultarBarcodeRecepcaoUnitaria(pedidoId, objetoGrid);
              }

            } else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              volumeSelecionado.dtEntregaPrevista = filtrado[0]?.pedido?.dtEntregaPrevista.toString().split(' ')[0];
              volumeSelecionado.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          let mensagemErro = response[0]?.erro.replace(/;/g, '<br>');

          if(!mensagemErro || mensagemErro == "") 
            mensagemErro = 'Não encontrei o pacote bipado. Tente bipar outro código de barras.';

          this.playAudiosService.playAudioError();
          this.openDialog('Erro', mensagemErro, 'Fechar');
          //this.toastrError('Não encontrei o pacote bipado. Tente bipar outro código de barras.')
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.toastrError('Erro ao consultar código de barras!')
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultaBarcodeManifestoTransferencia(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.GERACAO_MANIFESTO_TRANSFERENCIA,
    };
    this.updateLoading.emit(true);
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        if(!response || response[0]?.pedido == null){
          let mensagemErro = response[0]?.erro.replace(/;/g, '<br>');

          if(!mensagemErro || mensagemErro == "") 
            mensagemErro = 'Não encontrei o pacote bipado. Tente bipar outro código de barras.';

          this.playAudiosService.playAudioError();
          this.openDialog('Erro', mensagemErro, 'Fechar');
          return;
        }
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  volumeSelecionado.flgControlaCapacidade = result.pedido.flgControlaCapacidade;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeManifestoTransferencia(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeManifestoTransferencia(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado) {
                volumeSelecionado.pedidoId = parseInt(pedidoId);
                volumeSelecionado.flgControlaCapacidade = filtrado[0].pedido.flgControlaCapacidade;
              }

              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          let mensagemErro = response[0]?.erro.replace(/;/g, '<br>');

          if(!mensagemErro || mensagemErro == "") 
            mensagemErro = 'Não encontrei o pacote bipado. Tente bipar outro código de barras.';

          this.playAudiosService.playAudioError();
          this.openDialog('Erro', mensagemErro, 'Fechar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultaBarcodeInventario(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      alpha,
      tipoConsulta: TipoConsultaBarcode.INVENTARIO,
    };

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeInventario(result.pedido.pedidoId, objetoGrid, alpha);
                }
              }, TipoConsultaBarcode.INVENTARIO);
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeInventario(pedidoId, objetoGrid, alpha);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);

              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.playAudiosService.playBeepSound();
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
          this.onPackageSelected.emit(null);
        }
      },
      (err: HttpErrorResponse) => {
        this.playAudiosService.playBeepSound();
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcode(barcode,
    tipoConsulta = TipoConsultaBarcode.GAIOLA_CONSULTA_VOLUMES,
    alpha = null,
    mensagemNaoLocalizado = 'Não encontrei o pacote bipado. Tente bipar outro código de barras.') {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta,
      alpha
    };

    this.updateLoading.emit(true);

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        const filtrado = response;

        if (response?.length) {
          const estruturado = response.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;

          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, DEF_VOL_COLS,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcode(result.pedido.pedidoId, tipoConsulta, alpha);
                }
              }, tipoConsulta);
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));

            if (!pedidoEtiqueta && !check_find) {
              this.consultarBarcode(pedidoId, tipoConsulta, alpha);
            } else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado) volumeSelecionado.pedidoId = parseInt(pedidoId);

              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar(mensagemNaoLocalizado, 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false))
  }


  removeExistentes(vols: PedidoVolume[], listagem: BarcodeListarResponse[]) {

    //quando consultar pelo código de barras e possuir somente um volume, permitir seguir para exibir a mensagem de que item já está na grid;
    if (listagem?.length === 1) {
      let check_origin = ["PEDETIQUETA"];
      let check_find = listagem[0].origens?.find(o => check_origin.includes(o));
      if (check_find && listagem[0].pedido.volumes?.length == 1) return listagem;
    }

    const to_change = listagem?.filter(({ pedido: { pedidoId, volumes } }) =>
      vols.find((pedVolume) => pedVolume.pedidoId === pedidoId && volumes.map(({ pedEtiqueta }) => pedEtiqueta).includes(pedVolume.pedEtiqueta)
      )
    );

    to_change?.forEach(tc => {
      tc.pedido.volumes = tc.pedido.volumes.filter(v =>
        !vols.find
          (
            ({ pedidoId, pedEtiqueta }) => pedidoId === tc.pedido.pedidoId && pedEtiqueta === v.pedEtiqueta
          )
      )
    });

    return listagem;
  }


  modalSelecaoVolume(
    barcode: string,
    objetoVolume: BarcodeListarResponse[],
    exibirColunas: ObjGridVolCols,
    callbackSelecao: ModalSelecaoVolumeCallback,
    tipo?: TipoConsultaBarcode
  ) {
    const dialogRef = this.dialog.open(ModalSelecaoVolumesComponent, {
      disableClose: true,
      width: '800px',
      data: {
        objetoVolume,
        codigoBarras: barcode,
        exibirColunas,
        tipo
      },
      panelClass: 'modal-selecao-volume-panel'
    })

    dialogRef.afterClosed().subscribe((selecaoVolume) => callbackSelecao(selecaoVolume));
  }


  public consultarBarcodeGaiolaIncluirVolume(barcode, alpha, reuseSub?: Subject<any>): Subject<any> {
    const sub = reuseSub || new Subject();
    const obj = {
      barcode: barcode,
      tipoConsulta: TipoConsultaBarcode.GAIOLA_PEDIDOS_VOLUMES,
      alpha: alpha
    }
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        if (response?.length) {
          const estruturado = response.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});
          let exibe_modal = Object.keys(estruturado).length > 1 ||
          response.reduce(
            (acc, v): any => {
              return acc && v.pedido.volumes.find(vol => vol.manifTransfID);
            }
            , false);
          if (!exibe_modal) {
            for (let it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, response, DEF_VOL_COLS,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  sub.next(result);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcodeGaiolaIncluirVolume(result.pedido.pedidoId, alpha, sub);
                }
              }
            )
          }
          else {
            const objVolume = Object.assign(response[0], {
              volumeSelecionado: response[0].pedido.volumes[0],
            });
            sub.next(objVolume);
          }
        }
        else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => {
        this.updateLoading.emit(false)
      })
    return sub;
  }


  public consultarBarcodeGaiolaRemoverVolume(barcode): Subject<any> {
    const sub = new Subject;
    const obj = {
      barcode: barcode,
      tipoConsulta: TipoConsultaBarcode.GAIOLA_PEDIDOS_REMOVER_VOLUMES
    }
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        if (response?.length) {
          const estruturado = response.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});
          let exibe_modal = Object.keys(estruturado).length > 1 ||
          response.reduce(
            (acc, v): any => {
              return acc && v.pedido.volumes.find(vol => vol.manifTransfID);
            }
            , false);
          if (!exibe_modal)
            for (let it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, response, DEF_VOL_COLS,
              (result: SelecaoVolumes) => {
                if (result) {
                  sub.next(result);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcode(result.pedido.pedidoId);
                }
              }
            );
          } else {
            const objVolume = Object.assign(response[0], {
              volumeSelecionado: response[0].pedido.volumes[0],
            });
            sub.next(objVolume);
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => {
        this.updateLoading.emit(false)
      })
    return sub;
  }

  public consultarRecepcaoFisica(barcode, objetoGrid: ObjetoGridVolumes<any>, alpha?: string) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.RECEPCAO_FISICA,
      alpha
    };
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);
        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                  this.playAudiosService.playAudioSuccess();
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarRecepcaoFisica(result.pedido.pedidoId, objetoGrid);
                }
              }
            );
          } else {

            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            if (!pedidoEtiqueta) this.consultarRecepcaoFisica(pedidoId, objetoGrid);
            else {
              let volumeSelecionado = filtrado[0];
              volumeSelecionado.pedido.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado.pedido);
              this.playAudiosService.playAudioSuccess();
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
          this.playAudiosService.playAudioError();
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.playAudiosService.playAudioError();
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultaBarcodeMDT(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.RECEPCAO_MDT,
    };
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {

        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeMDT(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeMDT(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultaBarcodeManifestoDevolucaoAlterar(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.MDT_ALTERAR,
    };

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {

        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeManifestoDevolucaoAlterar(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {

            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeManifestoDevolucaoAlterar(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);

              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcodeGeracaoMDC(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.MDC_GERACAO,
      alpha
    };
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {

        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcodeGeracaoMDC(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultarBarcodeGeracaoMDC(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcodeColetaBar(
    barcode,
    objetoGrid?: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.PEDIDOSPENDENTESBARCODE,
      alpha
    };
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {

        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcodeColetaBar(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultarBarcodeColetaBar(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcodeColetaRom(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.PEDIDOSPENDENTESROMANEIO,
      alpha
    };
    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {

        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }
          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit(volumeSelecionado);
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultarBarcodeColetaRom(result.pedido.pedidoId, objetoGrid);
                }
              });
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultarBarcodeColetaRom(pedidoId, objetoGrid);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);
              this.onPackageSelected.emit(volumeSelecionado);
            }
          }
        } else {
          this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }
  public consultaBarcodeOperacaoVolume(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string,
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      alpha,
      tipoConsulta: TipoConsultaBarcode.GAIOLA_OPERACAO_VOLUME,
    };

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: any) => {
                if (!result || result === 'cancel') {
                 this.updateLoading.emit(false);
                  return;
                }

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit({
                    sucesso: true,
                    volume: volumeSelecionado,
                    dtEntregaPrevista: result.pedido.dtEntregaPrevista
                  });
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeOperacaoVolume(result.pedido.pedidoId, objetoGrid, alpha);
                }
              }, TipoConsultaBarcode.GAIOLA_OPERACAO_VOLUME);
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeOperacaoVolume(pedidoId, objetoGrid, alpha);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);


              this.onPackageSelected.emit({
                sucesso: true,
                volume: volumeSelecionado,
                dtEntregaPrevista: filtrado[0]?.pedido.dtEntregaPrevista
              });
            }
          }
        } else {
          //this.playAudiosService.playBeepSound();
          this.onPackageSelected.emit(
            {
              sucesso: false,
              mensagem: 'Não encontrei o pacote bipado. Tente bipar outro código de barras.'
            }
          );
        }
      },
      (err: HttpErrorResponse) => {
        this.playAudiosService.playBeepSound();
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }
  public consultaBarcodeOperacaoVolumeTelaConsultar(
    barcode,
    objetoGrid: ObjetoGridVolumes<ValidarManifestoTransferenciaResponse>,
    alpha?: string,
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      alpha,
      tipoConsulta: TipoConsultaBarcode.GAIOLA_OPERACAO_VOLUME,
    };

    this.manifestoService.barcodeListar(obj).subscribe(
      (response: BarcodeListarResponse[]) => {
        const vols = objetoGrid.grid.reduce(
          (arr: PedidoVolume[], { pedidoId, volumes }) => {
            volumes.forEach(v => arr.push({
              pedidoId,
              pedEtiqueta: v.pedEtiqueta
            })); return arr;
          }, []);

        const filtrado = this.removeExistentes(vols, response);
        if (filtrado?.length) {
          const estruturado = filtrado.reduce(
            (estrut, { pedido }) => {
              estrut[pedido.pedidoId] = [...new Set([
                ...(estrut[pedido.pedidoId] || []),
                ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
              ])];
              return estrut;
            }, {});

          var exibe_modal = Object.keys(estruturado).length > 1;
          if (!exibe_modal)
            for (var it in estruturado) {
              if (estruturado[it] && estruturado[it].length > 1) {
                exibe_modal = true;
                break;
              }
            }

          if (exibe_modal) {
            this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
              (result: SelecaoVolumes) => {
                if (!result) return;

                if (result?.volumeSelecionado) {
                  let volumeSelecionado = result?.volumeSelecionado;
                  volumeSelecionado.pedidoId = result.pedido.pedidoId;
                  this.onPackageSelected.emit({
                    sucesso: true,
                    volume: volumeSelecionado
                  });
                } else {
                  //busca por NRT para trazer os volumes
                  this.consultaBarcodeOperacaoVolume(result.pedido.pedidoId, objetoGrid, alpha);
                }
              }, TipoConsultaBarcode.GAIOLA_OPERACAO_VOLUME);
          } else {
            const pedidoId = Object.keys(estruturado)[0];
            const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
            let check_origin = ["PEDETIQUETA", "NRT"];
            let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
            if (!pedidoEtiqueta && !check_find) {
              this.consultaBarcodeOperacaoVolume(pedidoId, objetoGrid, alpha);
            }
            else {
              let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
              if (volumeSelecionado)
                volumeSelecionado.pedidoId = parseInt(pedidoId);


              this.onPackageSelected.emit({
                sucesso: true,
                volume: volumeSelecionado
              });
            }
          }
        } else {
          //this.playAudiosService.playBeepSound();
          this.onPackageSelected.emit(
            {
              sucesso: false,
              mensagem: 'Não encontrei o pacote bipado. Tente bipar outro código de barras.'
            }
          );
        }
      },
      (err: HttpErrorResponse) => {
        //this.playAudiosService.playBeepSound();
        console.error(err);
        return this.openSnackBar('Erro ao consultar código de barras!', 'OK', 3000, 'danger-snackbar');
      })
      .add(() => this.updateLoading.emit(false)
      )
  }
  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  openDialog(titulo: string, mensagemErro: string, textoBotao: string){
    this.dialogRef.open(ModalErroMensagemComponent,{
      data: {
        TituloErro: titulo,
        mensagem: mensagemErro,
        BotaoMesagem: textoBotao
      }
    });
  }


  private toastrError(mensagem: string): void {
    this.toastr.error(mensagem, 'Erro!', {
      disableTimeOut: true,
      closeButton: true,
      tapToDismiss: false
    });
  }

  public removerToastr(): void {
    this.toastr.clear();
  }

}

